import {useEffect, useState} from 'react';
import {
    Card,
    Container,
    Stack,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography
} from '@mui/material';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import {UserListHead} from '../components/_dashboard/user';
import * as CommunicationService from "../services/CommunicationService";
import * as LogicService from "../services/LogicService";
import * as AlertMapper from "../services/AlertMapper";

const TABLE_HEAD = [
    {id: 'id', label: 'Id', alignRight: false},
    {id: 'type', label: 'Tip', alignRight: false},
    {id: 'value', label: 'Valoare', alignRight: false},
];

export default function FeatureSwitches() {
    const [objectsRetreived, setObjectsRetreived] = useState(false);
    const [entityList, setEntityList] = useState([]);

    const getEntities = () => {
        CommunicationService.getAllFeatureSwitches()
            .then((response) => {
                setEntityList(response)
                setObjectsRetreived(true);
            })
            .catch((error) => LogicService.setAlertMessageAndSeverity(AlertMapper.getErrorMessage(error)));
    }

    const updateEntity = (id, checked) => {
        CommunicationService.updateFeatureSwitch(id, checked)
            .then((response) => {
                let updatedEntityIndex = entityList.findIndex(en => en.id === id);
                let copy = JSON.parse(JSON.stringify(entityList));
                copy[updatedEntityIndex].value = checked;
                setEntityList(copy);
            })
            .catch((error) => LogicService.setAlertMessageAndSeverity(AlertMapper.getErrorMessage(error)));
    }

    useEffect(() => {
            getEntities();
    }, []);


    return (
        <Page title="Cazier Judiciar Online – Eliberare Cazier Fara Deplasari">
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Feature switches
                    </Typography>
                </Stack>

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{minWidth: 800}}>
                            <Table>
                                <UserListHead
                                    headLabel={TABLE_HEAD}
                                />
                                <TableBody>
                                    {entityList
                                        .map((row) => {
                                            let {id, type, value} = row;
                                            return (
                                                <TableRow
                                                    hover
                                                    key={id}
                                                >
                                                    <TableCell padding="checkbox">
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" padding="checkbox">
                                                        <Stack direction="row" alignItems="center" spacing={2}>
                                                            <Typography variant="subtitle2" noWrap>
                                                                {id}
                                                            </Typography>
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell align="left">{type}</TableCell>
                                                    <TableCell align="left">
                                                        <Switch
                                                            checked={value}
                                                            onChange={(event) => updateEntity(id, event.target.checked)}
                                                            inputProps={{'aria-label': 'controlled'}}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                </Card>
            </Container>
        </Page>
    );
}
